import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { applyTheme, getTheme } from "@/utils/theme";
import { initPwa } from "@/lib/pwa";

// Aplica o tema salvo antes de renderizar (evita flash do tema errado).
applyTheme(getTheme());

// PWA: captura o beforeinstallprompt cedo + registra o service worker (prod).
initPwa();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
